import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state presents the signup form
///

// Register the application's routes configuration.
angular.module('flowingly.runner.sso').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.sso, {
    url: '/ssocallback?id_token&state&redirect',
    params: {},
    controller: 'runnerSSOController',
    controllerAs: 'ctrl'
  });
}
